import React from "react";
import { makeStyles, Theme, createStyles, withStyles, DialogTitleProps, IconButton, DialogContent, Grid, Typography } from "@material-ui/core";
import MuiDialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import CloseIcon from '@material-ui/icons/Close';
import ErrorButton from "components/ErrorButton";
import { useUnverifiedEmail } from "./useUnverifiedEmail";
import { ReactComponent as IconMail } from "assets/iconMail.svg";
import SvgIcon from "@material-ui/core/SvgIcon";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
        },
        modalHeading: {
            fontSize: "1.1875rem",
            fontWeight: 400,
            textTransform: "capitalize",
            color: "white",
            backgroundColor: "#D42C22",
            padding: '8px 24px',
        },
        headerTitle: {
            display: 'block',
            color: "inherit",
            fontFamily: "inherit",
            fontSize: "12px",
            fontWeight: 300,
        },
        headerSubtitle: {
            display: 'block',
            color: "inherit",
            fontFamily: "inherit",
            fontSize: "18px",
            fontWeight: 900,
            textTransform: "uppercase",
        },
        contentTitle: {
            display: 'block',
            color: "inherit",
            fontFamily: "inherit",
            fontSize: "1.2em",
            fontWeight: 900,
            marginBottom: "10px"
        },
        contentBody: {
            color: "inherit",
            fontFamily: "inherit",
            fontSize: "12px",
            fontWeight: 400,
        },
        contentEmail: {
            fontSize: "12px",
            fontWeight: 900,
            margin: "10px 0px"
        },
        modalImage: {
            margin: "auto",
            height: 104,
            width: 57,
            marginTop: 10,
            marginBottom: 20,
        },
        modalButton: {
            color: "white",
            fontFamily: "inherit",
            fontSize: "14px",
            fontWeight: 700,
            backgroundColor: "#D42C22",
            borderRadius: '10em',
            textTransform: 'none',
            paddingTop: 6,
            paddingBottom: 6,
            marginTop: 14,
            marginBottom: 8,
        },
        modalCloseButton: {
            color: "#D42C22",
            fontFamily: "inherit",
            fontSize: "14px",
            fontWeight: 700,
            backgroundColor: "white",
            borderRadius: '10em',
            textTransform: 'none',
            textAlign: 'center',
        },
        closeButton: {
            position: 'absolute',
            right: theme.spacing(1),
            top: theme.spacing(1),
            color: theme.palette.grey[500],
            padding: '4px',
        },
        resendButton: {
            textAlign: 'center',
            marginTop: "20px"
        },
        cancelButton: {
            textAlign: 'center',
        }
    }),
);

interface IProps {
    handleModalClose: () => void
    isOpen: boolean
}

const UnverifiedEmailModal = ({ handleModalClose, isOpen }: IProps) => {
    const classes = useStyles();

    const { resendVerificationEmail, user } = useUnverifiedEmail();

    async function handleResendVerificationEmail() {
        await resendVerificationEmail();
        handleModalClose();
    }

    const Dialog = withStyles((theme: Theme) => ({
        paper: {
            height: "auto",
            width: 291,
            borderRadius: "1rem",
        },
    }))(MuiDialog);

    const DialogTitle = (props: DialogTitleProps) => {

        return (
            <MuiDialogTitle disableTypography className={classes.modalHeading}>
                {props.children}
                <IconButton aria-label="close" className={classes.closeButton} onClick={handleModalClose}>
                    <CloseIcon style={{ color: "white", fontSize: '18px' }} />
                </IconButton>
            </MuiDialogTitle>
        );
    };

    return (
        <>
            <Dialog onClose={handleModalClose} aria-labelledby="customized-dialog-title" open={isOpen}>
                <DialogTitle id="customized-dialog-title">
                    <span className={classes.headerTitle}>Alert</span>
                    <span className={classes.headerSubtitle}>VERIFICATION REQUIRED</span>
                </DialogTitle>
                <DialogContent>
                    <Grid container>
                        <Grid item xs={12} style={{ textAlign: "center" }}>
                            <SvgIcon viewBox="0 0 91 56" style={{ fontSize: "7em", margin: "20px" }}>
                                <IconMail />
                            </SvgIcon>
                        </Grid>
                        <Grid item xs={12}>
                            <div style={{ textAlign: "center" }}>
                                <span className={classes.contentTitle}>
                                    To continue you must first verify your e-mail address
                                </span>
                                <Typography variant="body1" component="p" className={classes.contentBody}>
                                    Thank you for using BiasProof.  Please confirm your email address
                                </Typography>
                                <Typography variant="body1" component="p" className={classes.contentEmail}>
                                    {user.email}
                                </Typography>
                                <Typography variant="body1" component="p" className={classes.contentBody}>
                                    Check your inbox and follow the link. If you have not received a confirmation email, click the link below to resend.
                                </Typography>
                            </div>
                        </Grid>
                        <Grid item xs={12} className={classes.resendButton}>
                            <ErrorButton
                                label="Resend Verification Email"
                                onClick={handleResendVerificationEmail}
                            />
                        </Grid>
                        <Grid item xs={12} className={classes.cancelButton}>
                            <ErrorButton
                                secondary
                                label="Close"
                                onClick={handleModalClose}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
            </Dialog>
        </>
    )
}

export default UnverifiedEmailModal;